module.exports = __webpack_public_path__ + "img/amelia_earharts_goggles.fbd63598.jpg";